// Theme variables injected by gulp
var THEME_NAME;

THEME_NAME = 'bogen';

angular.module('app.controllers').controller('BannerGeneratorCtrl', ['$scope', '$rootScope', 'APIBanner', 'UI'].append(function(self, root, APIBanner, UI) {
  self.formProccess = false;
  self.sizes = [
    {
      name: '160x600px',
      sujets: ['']
    },
    {
      name: '300x250px',
      sujets: ['']
    },
    {
      name: '300x600px',
      sujets: ['']
    },
    {
      name: '728x90px',
      sujets: ['']
    },
    {
      name: '970x250px',
      sujets: ['']
    },
    {
      name: '970x90px',
      sujets: ['']
    }
  ];
  if (THEME_NAME === 'kuchen') {
    self.sizes.splice(3, 0, {
      name: '468x60px',
      sujets: ['', '2', '3', '4']
    });
  } else if (THEME_NAME === 'bike' || THEME_NAME === 'bogen' || THEME_NAME === 'fishing') {
    if (THEME_NAME === 'bike') {
      self.sizes.splice(3, 0, {
        name: '468x60px',
        sujets: ['']
      });
    }
    self.sizes.splice(1, 0, {
      name: '280x90px',
      sujets: ['']
    });
  } else {
    if (THEME_NAME === !'garten') {
      self.sizes.splice(1, 0, {
        name: '280x93px',
        sujets: ['']
      });
    }
  }
  if (THEME_NAME === 'agraria' || THEME_NAME === 'integra') {
    self.sizes = [
      {
        name: '160x600px',
        sujets: ['']
      },
      {
        name: '300x250px',
        sujets: ['']
      },
      {
        name: '728x90px',
        sujets: ['']
      },
      {
        name: '970x90px',
        sujets: ['']
      }
    ];
  }
  if (THEME_NAME === 'pferd') {
    self.sizes.splice(3, 0, {
      name: '468x60px',
      sujets: ['']
    });
    self.sizes.splice(4, 0, {
      name: '800x200px',
      sujets: ['']
    });
    self.sizes.splice(5, 0, {
      name: '960x720px',
      sujets: ['']
    });
    self.sizes.push({
      name: '1210x400px',
      sujets: ['']
    });
  }
  self.setSize = function(size) {
    self.data.size = size;
    self.setSujets(size);
    if (self[self.data.form] && self[self.data.form].$invalid) {
      return self.data;
    }
    return self.generate();
  };
  self.isSize = function(size) {
    return self.data.size === size;
  };
  self.setSujets = function(size) {
    var sizeConfig;
    // Get the sujets for the selected size
    sizeConfig = self.sizes.find(function(s) {
      return s.name === size;
    });
    // Create sujets objects with proper naming and src
    return self.data.sujets = sizeConfig.sujets.map(function(sujet) {
      var suffix;
      suffix = sujet === '' ? '' : sujet;
      return {
        name: size + suffix,
        src: 'assets/img/events/' + THEME_NAME + '/banners/Bannergenerator_' + size + suffix + '.png'
      };
    });
  };
  self.resetData = function(size = '160x600px', form = '') {
    self.data = {
      form: form,
      size: size,
      hall: '',
      booth: '',
      src: 'assets/img/events/' + THEME_NAME + '/banners/Bannergenerator_' + size + '.png'
    };
    return self.setSujets(size);
  };
  self.saveForm = function(form, name) {
    self[name] = form;
    return self.resetData('160x600px', name);
  };
  return self.generate = function() {
    var completedSujets, totalSujets;
    self.formProccess = true;
    
    // Track progress for multiple sujets
    totalSujets = self.data.sujets.length;
    completedSujets = 0;
    
    // Loop through all sujets and generate each one
    return self.data.sujets.forEach(function(sujet, index) {
      var sujetData;
      // Create a copy of data for this specific sujet
      sujetData = angular.copy(self.data);
      sujetData.src = sujetData.sujets[index].src;
      sujetData.sujetIndex = index;
      sujetData.sujetName = sujet.name;
      return (new APIBanner(sujetData)).$save({}, function(data) {
        completedSujets++;
        
        // Update the specific sujet with the generated result
        self.data.sujets[index].src = data.base64;
        self.data.sujets[index].generated = true;
        
        // Check if all sujets are completed
        if (completedSujets >= totalSujets) {
          self.formProccess = false;
          self[self.data.form].$setPristine();
          return self[self.data.form].$setUntouched();
        }
      }, function(response) {
        completedSujets++;
        self.data.sujets[index].error = response.data.error;
        
        // Check if all sujets are completed (even with errors)
        if (completedSujets >= totalSujets) {
          self.formProccess = false;
          return UI.notify(false, "Fehler beim Generieren einiger Banner");
        }
      });
    });
  };
}));
